import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Input } from "@progress/kendo-react-inputs";
import { button, icon, label, number } from "../../../config";
import { splitString } from "../../../utils";
import { prependString } from "../../../utils/common";

/**
 * Queue card body component for displaying queue details
 * @author Bhavana
 */

const QueueCardBody = ({
  index,
  gridRow,
  Name,
  owners,
  remainingOwners,
  memberCount,
  projectCount,
  totalTaskCount,
  RoleId,
  searchTerm,
  editOwnerRef,
  queueCardHook,
}) => {
  const {
    // State
    hoveredMembersArea,
    setHoveredMembersArea,
    setOpenAddTeamCardIndex,
    addTeamButtonRefs,
    openEditOwnerPopup,

    // Redux state
    assigneeList,

    // Handlers
    handleSearchChange,
    handleEditOwnerClick,
    handleViewChange,
  } = queueCardHook;

  const user = useSelector((state) => state?.auth?.user);

  /**
   * Get owner tooltip text
   * @author Bhavana
   */
  const getOwnerTooltip = () => {
    if (!owners || !assigneeList) return Name;
    const ownerIds = splitString(owners, ",");
    const ownerNames = ownerIds.map((id) => {
      const user = assigneeList.find((u) => u?.value == id);
      return user ? user?.label : id;
    });
    return ownerNames.join(", ");
  };

  return (
    <div className='queue-card-body'>
      <ul className='queue-details'>
        <li className='d-flex justify-content-between align-items-center'>
          <div
            className={`queue-member-section d-flex align-items-center ${RoleId === number.TWO ? "cursor-pointer queue-member-section-clickable" : "queue-member-section-readonly"} ${totalTaskCount > number.ZERO ? "has-tasks" : ""}`}
            ref={editOwnerRef}
            onClick={() => {
              if (RoleId === number.TWO) {
                handleEditOwnerClick(index);
              }
            }}>
            <div>
              <span className='queue-details-icon'>{icon?.PERSON_TOGGLE}</span>
              <span className='queue-manager-text text-truncate'>
                {`${label?.CREATOR} : ${Name}${remainingOwners ? ` + ${remainingOwners}` : ""}`}
              </span>
            </div>
          </div>
          {totalTaskCount > number.ZERO && (
            <div
              className={`queue-tasks-section d-flex align-items-center ${RoleId === number.TWO ? "cursor-pointer link-text" : ""}`}
              onClick={() => {
                if (RoleId === number.TWO) {
                  handleViewChange(label.GRID, gridRow);
                }
              }}>
              <span>{icon?.ADD_TASK}</span>
              <span>{totalTaskCount + " " + label?.OPEN_TASKS}</span>
            </div>
          )}
        </li>

        <li className='d-flex justify-content-between'>
          <div>
            <span className='queue-details-icon'>{icon?.PROJECTS}</span>
            <span className='queue-member-count'>{`${memberCount} Members`}</span>
            <span>{` (${projectCount} ${user?.operationalTeamName}${projectCount > number.ONE ? "s" : ""})`}</span>
          </div>
          <div>
            {RoleId === number.TWO && (
              <button
                className='square-icon square-icon-small invisible'
                title={prependString(user?.operationalTeamName ? user?.operationalTeamName : label?.TEAM, button?.ADD + " ")}
                onClick={() => setOpenAddTeamCardIndex(index)}
                disabled={RoleId !== number.TWO}
                ref={addTeamButtonRefs.current[index]}>
                {icon.CIRCLEPLUS}
              </button>
            )}
          </div>
          <div className='d-flex ml-auto'>
            <span className='position-relative invisible'>
              <Input
                className='team-search-field'
                placeholder={label?.SEARCH + user?.operationalTeamName}
                value={searchTerm}
                onChange={(e) => handleSearchChange(index, e?.value)}
              />
              <span className='position-absolute team-search-icon'>{icon?.SEARCH}</span>
            </span>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default QueueCardBody;
